import { createId, DEFAULT_RESERVE_PCT, SCHEMA_VERSION } from './project';
import { createComponent } from './project';
import { defaultComponentKinds } from './catalog';
import type { ComponentKind, FieldValue, Project } from './types';

/** 示例配置：10 英寸桨 / 4S 电池的航拍四轴，用于快速了解工具怎么用。 */
const SAMPLE_VALUES: Record<ComponentKind, { label?: string; qty?: number; fields: Record<string, FieldValue> }> = {
  frame: { label: '碳纤维机架 450', fields: { weight_g: 180, price: 199 } },
  motor: {
    label: '无刷电机 920KV',
    fields: {
      weight_g: 55,
      price: 89,
      thrust_g: 1250,
      kv: 920,
      max_current_a: 28,
      efficiency_g_per_w: 7.5,
    },
  },
  esc: {
    label: '电调 40A',
    fields: { weight_g: 26, price: 69, cont_current_a: 40, peak_current_a: 60 },
  },
  propeller: {
    label: '三叶桨 10×4.5',
    fields: { weight_g: 12, price: 15, diameter_in: 10, pitch_in: 4.5, blades: 3 },
  },
  battery: {
    label: '锂聚合物 4S 5200mAh',
    fields: { weight_g: 520, price: 399, capacity_mah: 5200, cells: 4, discharge_c: 30 },
  },
  fc: { label: '飞控', fields: { weight_g: 45, price: 399 } },
  vtx: { label: '图传', fields: { weight_g: 32, price: 259 } },
  rx: { label: '接收机', fields: { weight_g: 12, price: 89 } },
  payload: { label: '云台相机', fields: { weight_g: 250, price: 1299 } },
  custom: { fields: {} },
};

/** 生成一份填好参数的示例项目（不写入存储，由调用方决定）。 */
export function createSampleProject(): Project {
  const timestamp = new Date().toISOString();
  return {
    id: createId('p'),
    name: '示例：10 英寸 4S 航拍四轴',
    note: '参考配置，可直接改成自己的参数。',
    schemaVersion: SCHEMA_VERSION,
    reservePct: DEFAULT_RESERVE_PCT,
    createdAt: timestamp,
    updatedAt: timestamp,
    components: defaultComponentKinds().map((kind) => {
      const sample = SAMPLE_VALUES[kind];
      return createComponent(kind, {
        qty: sample.qty,
        ...(sample.label ? { label: sample.label } : {}),
        fields: { ...sample.fields },
      });
    }),
  };
}
